import { render } from "./TicketImportTemplate.vue?vue&type=template&id=1a01b752"
import script from "./TicketImportTemplate.vue?vue&type=script&lang=js"
export * from "./TicketImportTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__